import { render, staticRenderFns } from "./TaskRadar.vue?vue&type=template&id=c64bd4cc&scoped=true&"
import script from "./TaskRadar.vue?vue&type=script&lang=js&"
export * from "./TaskRadar.vue?vue&type=script&lang=js&"
import style0 from "./TaskRadar.vue?vue&type=style&index=0&id=c64bd4cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64bd4cc",
  null
  
)

export default component.exports